var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTrashBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 3.79987H13.6005L12.4945 13.7539C12.4566 14.0965 12.2936 14.4131 12.0368 14.643C11.7801 14.8729 11.4475 15 11.1029 15H4.89801C4.55335 15 4.2208 14.8729 3.96403 14.643C3.70725 14.4131 3.54431 14.0965 3.5064 13.7539L2.40039 3.79987Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74229 1.80285C4.85552 1.56272 5.03469 1.35974 5.2589 1.21758C5.48311 1.07542 5.74312 0.999936 6.0086 0.999939H9.99303C10.2586 0.999803 10.5188 1.07522 10.7431 1.21739C10.9675 1.35956 11.1468 1.56261 11.26 1.80285L12.2008 3.79996H3.80078L4.74229 1.80285Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.79987H15.0001",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBox);
export default __webpack_public_path__ + "static/media/trashBox.c27bf796d7229ab9a549a0afc7c3ab9c.svg";
export { ForwardRef as ReactComponent };